import { Stack, styled } from "@mui/material";

export const StyledFileContext = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  listStyle: "none",
  width: "14rem",
  height: "2rem",
  fontSize: "0.875rem",
  padding: "0.25rem",
  backgroundColor: theme.customColors.backgroundSecondary,
  color: theme.customColors.textInput,
  border: `1px solid  ${theme.customColors.border}`,
  borderRadius: "0.5rem",
  overflow: "hidden"
}));
export const StyledListFiles = styled(Stack)(() => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "1rem"
}));
